import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerStatusPickerComponent } from './borrower-status-picker/borrower-status-picker.component';
import { BorrowerStatusPickerSmartComponent } from './borrower-status-picker-smart/borrower-status-picker-smart.component';
import { BorrowerStatusReasonDialogComponent } from './borrower-status-reason-dialog/borrower-status-reason-dialog.component';
import { FormlyModule } from '@ngx-formly/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { ChangeBorrowerStatusDialogComponent } from 'ng2-app/borrower-header/borrower-status-display/change-borrower-status/change-borrower-status-dialog.component';

@NgModule({
  declarations: [
    BorrowerStatusPickerComponent,
    BorrowerStatusPickerSmartComponent,
    BorrowerStatusReasonDialogComponent,
    ChangeBorrowerStatusDialogComponent,
  ],
  imports: [
    CommonModule,
    FormlyModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
  exports: [
    BorrowerStatusPickerSmartComponent,
    ChangeBorrowerStatusDialogComponent,
  ],
  providers: [
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'never',
        appearance: 'legacy',
      }
    }
  ]
})
export class BorrowerStatusPickerModule { }
